import * as React from "react";

// The Invoiced check and the box its services open in share one blue.
export const INVOICED_BLUE = "#3b82f6";

export enum InvoicedMark {
  INVOICED = "INVOICED",
  QUOTED = "QUOTED",
}

export const MARK_LABELS: Record<InvoicedMark, string> = {
  [InvoicedMark.INVOICED]: "Invoiced",
  [InvoicedMark.QUOTED]: "Quoted, not invoiced",
};

// Item, result in the middle, then a narrow invoiced column.
// Fixed, not auto: each row is its own grid, and the column must line up under its "Invoiced" heading.
export const COLUMNS: React.CSSProperties = { gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.4fr) 74px" };
